// extracted by mini-css-extract-plugin
export default {"studio-editor":"studioEditor_studio-editor__P2Ovn"};